import React, { Component } from 'react'
import { connect } from 'react-redux'
import { router } from 'router'
import EventBus from 'src/events'
import { TweenMax, Power3 } from 'gsap'
import get from 'lodash/get'

import values from 'src/values'
import Scroller from 'src/utils/scroller'
import Loader from './loader'
import resize from 'src/utils/resize'

import Page from './Page'

import './App.scss'

export default class App extends Component {
  constructor() {
    super()
    this.pages = []
    this.index = 0
  }

  componentDidMount() {
    router.setApp(this)
    router.start()
    values.onResize()

    this.body = document.getElementsByTagName('body')[0]

    if ('scrollRestoration' in window.history) {
      // Back off, browser, I got this...
      window.history.scrollRestoration = 'manual'
    }

    Scroller.start()
  }

  shouldComponentUpdate(nextProps) {
    return false
  }

  get currentPage() {
    return this.pages[this.index]
  }

  get nextPage() {
    return this.pages[(this.index + 1) % this.pages.length]
  }

  setPage(component, params, route, localized, main) {
    if (route === 'redirect') {
      router.goto('/fr')
      return
    }

    const current = this.currentPage
    const next = this.nextPage

    this.currentRoute = this.nextRoute || route
    this.nextRoute = route

    if (
      this.currentRoute === this.nextRoute &&
      component !== current.component &&
      !this.isNavigate
    ) {
      this.isNavigate = true

      next
        .setComponent(component, params.params, route, localized, main)
        .then(() => {
          this.refs.loader.animateIn(route, this.previousParams).then(() => {
            next.module.active = true
            TweenMax.set(next.el, { autoAlpha: 1 })
            next.el.classList.add('active')
            next.module
              .load()
              .then(() => next.module.willAnimateIn())
              .then(() => {
                this.refs.loader.animateEnded().then(() => {
                  next.module
                    .animateIn(this.currentRoute, this.previousParams)
                    .then(() => {
                      this.previousParams = params
                    })
                })
              })
          })
        })
    } else if (this.currentRoute === this.nextRoute) {
      const currentModule =
        current.module && current.module.active ? current : next

      currentModule.module.setComponent(
        component,
        params.params,
        route,
        localized,
        main
      )
    } else {
      const currentModule =
        current.module && current.module.active ? current : next
      const nextModule = next.module && next.module.active ? current : next

      currentModule.module
        .animateOut(this.nextRoute, this.previousParams)
        .then(() => {
          currentModule.el.classList.remove('active')

          nextModule
            .setComponent(component, params.params, route, localized, main)
            .then(() => {
              nextModule.el.classList.add('active')
              nextModule.module.active = true
              currentModule.module.active = false
            })
            .then(() => {
              return nextModule.module.load()
            })
            .then(() => nextModule.module.willAnimateIn())
            .then(() => {
              currentModule.setComponent(null, null, null, localized)

              nextModule.module
                .animateIn(this.currentRoute, this.previousParams)
                .then(() => {
                  this.previousParams = params
                })
            })
        })
    }

    this.index = (this.index + 1) % this.pages.length
  }

  render() {
    return (
      <div className={`app-wrapper`}>
        <div ref="content" className="content-wrapper">
          <Page
            ref={el => {
              this.pages.push(el)
            }}
          />
          <Page
            ref={el => {
              this.pages.push(el)
            }}
          />
        </div>
        <Loader ref="loader" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/App.js